<ng-container *transloco="let t">


  <p>{{ t("Every month we review your workers' OK Alone activity and they will be awarded a number of badges for features used, milestones reached and their rankings in relation to other workers in the company, country and world wide.") }}</p>
    <p>{{ t('Here are a list of badges and awards available for workers') }}</p>

    <div class="row">
      <div class="col-md-6">

  <div class="cardcard-solid">
  <div class="card-header with-border">
      <h2>{{ t('Feature Usage Badges') }}</h2>
      <p>{{ t('Workers can achieve a number of different badges for their usage of the app and other lone worker tools. These all contribute to their overall score.') }}</p>

  </div>
  <div class="card-body">
  <table class="table table-striped">

    <tr><td><img src="https://okalone.net/awards/badges/feature/app-badge.svg" width="100px"></td><td>
    <h3>{{ t('App User') }}</h3><p>{{ t('The worker has logged in and used the app') }}</p></td></tr>

    <tr><td><img src="https://okalone.net/awards/badges/feature/shift-start-badge.svg" width="100px"></td><td>
    <h3>{{ t('Started A Shift') }}</h3><p>{{ t('The worker has started a shift using the app, SMS or a phone call.') }}</p></td></tr>

    <tr><td><img src="https://okalone.net/awards/badges/feature/checked-in-badge.svg" width="100px"></td><td>
    <h3>{{ t('Checked In') }}</h3><p>{{ t('The worker has checked in using the app, SMS or a phone call.') }}</p></td></tr>

    <tr><td><img src="https://okalone.net/awards/badges/feature/gps-badge.svg" width="100px"></td><td>
    <h3>{{ t('GPS User') }}</h3><p>{{ t('The worker correctly used GPS to provide up-to-date location points.') }}</p></td></tr>

    <tr><td><img src="https://okalone.net/awards/badges/feature/man-down-badge.svg" width="100px"></td><td>
    <h3>{{ t('Man Down User') }}</h3><p>{{ t('The worker uses the man down feature on the app to monitor their movement and alert monitors if they stop moving and cannot be contacted.') }}</p></td></tr>

    <tr><td><img src="https://okalone.net/awards/badges/feature/high-risk-badge.svg" width="100px"></td><td>
    <h3>{{ t('High Risk User') }}</h3><p>{{ t('This worker has used the high risk function on the phone to reduce the check in time when going into a more risky situation.') }}</p></td></tr>

    <tr><td><img src="https://okalone.net/awards/badges/feature/sms-badge.svg" width="100px"></td><td>
    <h3>{{ t('SMS User') }}</h3><p>{{ t('The worker uses SMS to update their status, including starting shifts or checking in.') }}</p></td></tr>


    <tr><td><img src="https://okalone.net/awards/badges/feature/whatsapp-badge.svg" width="100px"></td><td>
    <h3>{{ t('WhatsApp User') }}</h3><p>{{ t('This worker is using WhatsApp to update their status, including starting shifts or checking in.') }}</p></td></tr>

    <tr><td><img src="https://okalone.net/awards/badges/feature/phonecall-badge.svg" width="100px"></td><td>
    <h3>{{ t('Phone Call User') }}</h3><p>{{ t('This worker is using phone calls to update their status, including starting shifts or checking in.') }}</p></td></tr>

    <tr><td><img src="https://okalone.net/awards/badges/feature/google-assistant-badge.svg" width="100px"></td><td>
    <h3>{{ t('Google Assistant') }}</h3><p>{{ t('The worker uses Google Assistant to manage their shift status using voice commands.') }}</p></td></tr>

    <tr><td><img src="https://okalone.net/awards/badges/feature/message-badge.svg" width="100px"></td><td>
    <h3>{{ t('Message Sent') }}</h3><p>{{ t('This worker has sent a message to their monitors in the app.') }}</p></td></tr>

    <tr><td><img src="https://okalone.net/awards/badges/feature/voicemail-badge.svg" width="100px"></td><td>
    <h3>{{ t('Left Voice Message') }}</h3><p>{{ t('The worker has left a voice mail when making a phone call to OK Alone.') }}</p></td></tr>

    <tr><td><img src="https://okalone.net/awards/badges/feature/shortcuts-badge.svg" width="100px"></td><td>
    <h3>{{ t('Android Shortcuts (Coming Soon)') }}</h3><p>{{ t('The worker uses shortcuts for the OK Alone app to check in faster or make other status updates.') }}</p></td></tr>

    <tr><td><img src="https://okalone.net/awards/badges/feature/siri-badge.svg" width="100px"></td><td>
    <h3>{{ t('Siri User (Coming Soon)') }}</h3><p>{{ t('The worker uses Siri to manage their shift status using voice commands.') }}</p></td></tr>

  </table>
  </div>
  </div>
  </div>

  <div class="col-md-6">

  <div class="cardcard-solid">
  <div class="card-header with-border">
    <h2>{{ t('Milestone Badges') }}</h2>
    <p>{{ t('As workers continue to use OK Alone, they can reach a number of milestones which show they are achieving safety goals.') }}</p>

  </div>
  <div class="card-body">
  <table class="table table-striped">

  <tr><td><img src="https://okalone.net/awards/badges/time/safe-shifts-5.svg" width="100px"></td><td>
  <h3>{{ t('Safe Shifts') }}</h3><p>{{ t('If a worker completes a shift of at least 2 hours with no alerts, we consider that a safe shift.') }}<br/>
    1 {{ t('Star') }} - 10 {{ t('Safe Shifts') }}<br/>
    2 {{ t('Stars') }} - 25 {{ t('Safe Shifts') }}<br/>
    3 {{ t('Stars') }} - 50 {{ t('Safe Shifts') }}<br/>
    4 {{ t('Stars') }} - 100 {{ t('Safe Shifts') }}<br/>
    5 {{ t('Stars') }} - 250 {{ t('Safe Shifts') }}<br/>
  </p></td></tr>

  <tr><td><img src="https://okalone.net/awards/badges/time/safe-weeks-5.svg" width="100px"></td><td>
  <h3>{{ t('Safe Weeks') }}</h3><p>{{ t('If a worker completes a week with all safe shifts (one shift equals at least 2 hours with no alerts), we count that as a safe week. They must have at least 3 shifts in the week to qualify.') }}<br/>
  1 {{ t('Star') }} - 1 {{ t('Safe Week') }}<br/>
  2 {{ t('Stars') }} - 5 {{ t('Safe Weeks') }}<br/>
  3 {{ t('Stars') }} - 10 {{ t('Safe Weeks') }}<br/>
  4 {{ t('Stars') }} - 20 {{ t('Safe Weeks') }}<br/>
  5 {{ t('Stars') }} - 40 {{ t('Safe Weeks') }}<br/>
  </p></td></tr>
  </table>
  </div>
  </div>



  <div class="cardcard-solid">
  <div class="card-header with-border">
    <h2>{{ t('Ranking Badges') }}</h2>
    <p>{{ t('Each month workers are awarded a score out of 100 based on their app usage and other lone worker assessments in the system. These scores are then used to rank them against other colleagues and workers in their country and across the world. Worker scores are also used to rank companies, by taking the average score of their top 5 workers.') }}</p>

  </div>
  <div class="card-body">
  <table class="table table-striped">

  <tr><td><img src="https://okalone.net/awards/badges/ranking/place-1.svg" width="100px"></td><td>
  <h3>{{ t('Worker of the Month') }}</h3><p>{{ t('Your top worker for this month is award the 1st place badges, there are also badges for 2nd and 3rd.') }}</p></td></tr>

  <tr><td><img src="https://okalone.net/awards/badges/ranking/group-1.svg" width="100px"></td><td>
  <h3>{{ t('Group of the Month') }}</h3><p>{{ t('If your company has at least 3 groups, we also rank them by taking the scores from the top 3 workers. All workers in the winning group get this badge.') }}</p></td></tr>

  <tr><td><img src="https://okalone.net/awards/badges/ranking/ca-place-1.svg" width="100px"></td><td>
  <h3>{{ t('Country/Worldwide Worker of the Month') }}</h3><p>{{ t('The top 10 workers in their country and worldwide are awarded special badges.') }}</p></td></tr>



  <tr><td><img src="https://okalone.net/awards/badges/ranking/ww-company-1.svg" width="100px"></td><td>
  <h3>{{ t('Company of the Month') }}</h3><p>{{ t('The top 10 companies in the world and in your country are ranked and awarded badges. The ranking is worked out by taking the average score of the top 5 workers.') }}</p></td></tr>
  </table>
  </div>
  </div>
  </div>
  </div>

</ng-container>
